
import { useState } from 'react';

export default function QRCodeSection() {
  const [copied, setCopied] = useState(false);
  const currentUrl = window.location.href;
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(currentUrl)}&bgcolor=ffffff&color=0d9488`;

  const handleCopy = () => {
    navigator.clipboard.writeText(currentUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <section className="mb-8">
      <h4 className="text-2xl font-bold text-gray-900 mb-6">
        <a href="#qr-code">QR 코드로 공유하기</a>
      </h4>

      <div className="bg-gray-50 rounded-lg p-8 flex flex-col md:flex-row items-center gap-8">
        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
          <div className="w-[200px] h-[200px]">
            <img
              src={qrUrl}
              alt="서울 N 호텔 동대문 QR 코드"
              title="서울 N 호텔 동대문 QR 코드 - 스캔하여 호텔 페이지 방문"
              width={200}
              height={200}
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        <div className="flex-1 text-center md:text-left">
          <h3 className="text-lg font-bold text-gray-900 mb-2">스마트폰으로 스캔하세요</h3>
          <p className="text-sm text-gray-600 mb-4 leading-relaxed">
            QR 코드를 스캔하면 이 호텔 페이지로 바로 이동합니다.<br />
            친구나 가족에게 공유해 보세요.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-3">
            <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-lg px-4 py-2.5 text-sm text-gray-500 max-w-xs w-full overflow-hidden">
              <i className="ri-link w-4 h-4 flex items-center justify-center text-teal-600"></i>
              <span className="truncate">{currentUrl}</span>
            </div>
            <button
              onClick={handleCopy}
              className="whitespace-nowrap flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white text-sm font-medium px-5 py-2.5 rounded-lg transition-colors cursor-pointer"
            >
              <i className={`${copied ? 'ri-check-line' : 'ri-file-copy-line'} w-4 h-4 flex items-center justify-center`}></i>
              {copied ? '복사됨!' : '링크 복사'}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
